import { Stack } from '@mui/material';

import { CohortAndStudyPeriodSection } from './CohortAndStudyPeriodSection';
import { TablesSection } from './TablesSection';
import { TablesStaleBanner } from '../../components/TablesStaleBanner';
import { useAnalysisDefinitionTab } from '../../hooks/useAnalysisDefinitionTab';

// Analytical dataset land in follow-up work.
export const AnalysisDefinitionTab = () => {
  const { isLoading, resultsStaleness } = useAnalysisDefinitionTab();

  return (
    <Stack spacing={6} data-testid="analysis-definition-tab">
      {resultsStaleness && <TablesStaleBanner staleness={resultsStaleness} />}
      <CohortAndStudyPeriodSection isLoading={isLoading} />
      <TablesSection isLoading={isLoading} />
    </Stack>
  );
};
